import * as React from 'react';
export const IcHighSpeed = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.93 12.83A10 10 0 0013.23 4a10 10 0 00-8.16 2.74 9.94 9.94 0 00-2.43 3.69A10 10 0 003.36 19c.18.3.43.55.73.73a2 2 0 001 .27h13.83a2.049 2.049 0 001-.27 2 2 0 00.72-.73 9.86 9.86 0 001.29-6.17zM6.57 16.59a1 1 0 01-1.43 1.28 1 1 0 01-.38-.42A8 8 0 014 14a8 8 0 017.526-7.967 8 8 0 013.904.757c.129.051.248.126.35.22.091.1.166.215.22.34.048.131.072.27.07.41a1.07 1.07 0 01-.1.39.899.899 0 01-.25.33.92.92 0 01-.35.19 1 1 0 01-.41.05 1.12 1.12 0 01-.39-.13 6 6 0 00-3.6-.5 5.94 5.94 0 00-3.22 1.67 6 6 0 00-1.18 6.83zm6.83-.53c-.08.182-.191.348-.33.49-.135.147-.303.26-.49.33-.183.08-.38.12-.58.12a1.5 1.5 0 010-3h.14l5.18-4.75a1 1 0 01.34-.2 1 1 0 01.77 0 .87.87 0 01.31.23c.088.097.16.209.21.33.036.127.053.258.05.39-.01.13-.04.259-.09.38-.06.12-.14.229-.24.32l-5.17 4.78c.008.198-.027.396-.1.58zm5.82 1.37a1 1 0 01-.37.42 1 1 0 01-.54.15 1 1 0 01-.94-.67 1.05 1.05 0 010-.76A5.868 5.868 0 0018 14a1 1 0 011.384-.926c.122.05.233.123.326.216A1.001 1.001 0 0120 14a7.69 7.69 0 01-.78 3.43z'
      fill='currentColor'
    />
  </svg>
);
